import { takeLatest, put, call, all } from 'redux-saga/effects';
import {
    startFetchProfile,
    setProfileData,
    setProfileError,
    startFetchAddress,
    startFetchEducation,
    startFetchExperience,
    startFetchDocuments,
    startFetchBankAccount,
    setAddressData,
    setEducationData,
    setExperienceData,
    setDocumentsData,
    setBankAccountData
} from './profileData.slice.selector';

import {
    fetchUserProfileAPI,
    fetchEmployeeAddressAPI,
    fetchEmployeeEducationAPI,
    fetchEmployeeExperienceAPI,
    fetchEmployeeDocumentsAPI,
    fetchEmployeeBankAccountAPI,
} from '../../Api/ProfileAPI/profileAPI';

import { getMyCompanyData } from '../../Api/UserAuthAPI/userAuth';

const unwrap = (resp) => {
    if (!resp) return null;
    if (Array.isArray(resp)) return resp || null;
    if (typeof resp === 'object') return resp;
    return null;
};


function* fetchProfileSaga() {
    try {
        const [profileResp, companyData] = yield all([
            call(fetchUserProfileAPI),
            call(getMyCompanyData),
        ]);

        const profile = Array.isArray(profileResp?.profile)
            ? profileResp.profile[0]
            : profileResp?.profile || profileResp || null;

        yield put(setProfileData({ profile, company: companyData || null }));
    } catch (error) {
        yield put(setProfileError('Unable to load profile'));
    }
}

function* fetchAddressSaga() {
    try {
        const resp = yield call(fetchEmployeeAddressAPI);
        yield put(setAddressData(unwrap(resp)));
    } catch (e) {
        yield put(setProfileError('Unable to load address'));
    }
}

function* fetchEducationSaga() {
    try {
        const resp = yield call(fetchEmployeeEducationAPI);
        yield put(setEducationData(unwrap(resp)));
    } catch (e) {
        yield put(setProfileError('Unable to load education'));
    }
}

function* fetchExperienceSaga() {
    try {
        const resp = yield call(fetchEmployeeExperienceAPI);
        yield put(setExperienceData(unwrap(resp)));
    } catch (e) {
        yield put(setProfileError('Unable to load experience'));
    }
}

function* fetchDocumentsSaga() {
    try {
        const resp = yield call(fetchEmployeeDocumentsAPI);
        yield put(setDocumentsData(unwrap(resp)));
    } catch (e) {
        yield put(setProfileError('Unable to load documents'));
    }
}

function* fetchBankAccountSaga() {
    try {
        const resp = yield call(fetchEmployeeBankAccountAPI);
        yield put(setBankAccountData(unwrap(resp)));
    } catch (e) {
        yield put(setProfileError('Unable to load bank account'));
    }
}

export default function* profileDataSaga() {
    yield takeLatest(startFetchProfile.type, fetchProfileSaga);
    yield takeLatest(startFetchAddress.type, fetchAddressSaga);
    yield takeLatest(startFetchEducation.type, fetchEducationSaga);
    yield takeLatest(startFetchExperience.type, fetchExperienceSaga);
    yield takeLatest(startFetchDocuments.type, fetchDocumentsSaga);
    yield takeLatest(startFetchBankAccount.type, fetchBankAccountSaga);
}

